namespace RedBullMOBILE360.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}

